import { useChatListState } from "@/zustand/ChatListState";
import { ChatUserAction, useNavigationState } from "@/zustand/NavigationState";
import { Search, RefreshCcwDot } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  searchAction: ChatUserAction;
};

export default function SearchChatInput({ searchAction }: Props) {
  const { t } = useTranslation();
  const setChatUserAction = useNavigationState(
    (state) => state.setChatUserAction,
  );
  const chatListSyncing = useChatListState((state) => state.chatListSyncing);
  return (
    <div className="mt-2 px-4 py-1">
      <div
        onClick={() => {
          if (chatListSyncing) {
            return;
          }
          setChatUserAction(searchAction);
        }}
        className="flex h-8 items-center gap-2 rounded-xl bg-foreground/10 px-3 text-foreground/50 lg:cursor-text"
      >
        {chatListSyncing ? (
          <>
            <RefreshCcwDot size={14} /> {t("syncing")}
          </>
        ) : (
          <>
            <Search size={14} /> {t("search")}
          </>
        )}
      </div>
    </div>
  );
}
